import {getContextHelpers, toObjectKeys} from 'ad-hok-utils'

import {WebformFields} from 'graphql/deserializedTypes/WebformFields'

const [addWebformsContextProvider, addWebformsContext] = getContextHelpers<{
  webforms: WebformFields[]
}>(toObjectKeys(['webforms']))

export {addWebformsContextProvider, addWebformsContext}
